import { call, put, select, takeLatest } from 'redux-saga/effects'
import { SEND_EMAIL } from './constants'
import { sendEmail } from './actions'
import { apiSendEmail } from './services'
import { getOptionFromState } from 'hocs/OptionsHOC/helpers'
import { getCustomer } from 'helpers'
import { getNotify } from '../../context/NotificationContext'; 

function* fetchTopicWorker(action) {
  const getOption = yield select(getOptionFromState)
  const displayName = getOption('displayName')
  const email = getOption('emailFromAddress')
  const subject = getOption('emailSubject')
  const excludeEmail = getOption('excludeEmail')
  const notify = getNotify();

  const response = yield call(
    apiSendEmail,
    action.to,
    action.body,
    displayName,
    email,
    subject,
    excludeEmail
  )

  if (response.ok) {
    yield put(sendEmail.success())
    yield call(notify, {
      message: 'Email sent successfully!',
      level: 'success',
      
    });
  } else {
    yield put(sendEmail.failure())
    yield call(notify, {
      message: 'Failed to send email!',
      level: 'error',
    });
  }
}

export default function* watcher() {
  yield takeLatest(SEND_EMAIL.REQUEST, fetchTopicWorker)
}
